import { styled, useTheme } from "@mui/system";
import { Typography, Avatar } from "@mui/material";
import { PriceComponent } from "components/Shared/Dashboard/styled";
import RightArrowIcon from "assets/icons/RightArrowIcon";
import { MainCardContainer, TitleSection, TagComponent } from "./styled";
import { formatPrice } from "helpers/dataFormat";

const BalanceContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "190px",
}));
const LowerSection = styled("div")(({ theme }) => ({
  width: "100%",
  display: "grid",
  height: "100%",
  gridTemplateColumns: "24% 76%",
  justifyContent: "space-between",
}));
const ProfileSection = styled("div")(({ theme }) => ({
  display: "grid",
  height: "100%",
  justifyContent: "center",
  gridTemplateRows: "12% 35% 12%",
  gridTemplateColumns: "100%",

  paddingTop: "24px",
  gridGap: "5%",
  borderLeft: `solid 2px ${theme.palette.disabled.light}`,
}));
const ItemContainer = styled("div")(({ theme }) => ({
  width: "100%",
  // backgroundColor: 'red',
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
const StyledAvatar = styled(Avatar)(({ theme }) => ({
  height: "96px",
  width: "96px",
  padding: "8px",
  border: `solid 2px ${theme.palette.disabled.contrastText}`,
}));
const DetailsSection = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "0 30px 0 30px",
  display: "grid",
  gridTemplateRows: "25%",
}));
const DetailsItem = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "24px 0 24px 0",
  borderBottom: `solid 2px ${theme.palette.disabled.light}`,
  display: "grid",
  gridTemplateColumns: "25% 25% 25% 25%",
}));
const AddressItem = styled(DetailsItem)(({ theme }) => ({
  gridTemplateColumns: "75% 25%",
}));
const DetailsSubItem = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));
const DetailsSubItemTitle = styled(Typography)(({ theme }) => ({
  marginBottom: "8px",
}));

const MainCard = ({ data }: { data: any }) => {
  const theme = useTheme();

  const displayAddress = () => {
    let flag = false;
    let address = "";

    const checkFlag = () => {
      if (!flag) {
        flag = true;
      } else {
        address += " - ";
      }
    };

    if (data.country) {
      checkFlag();
      address += data.country;
    }

    if (data.state) {
      checkFlag();
      address += data.state;
    }

    if (data.city) {
      checkFlag();
      address += data.city;
    }

    if (data.address) {
      checkFlag();
      address += data.address;
    }

    return flag ? address : null;
  };

  return (
    <MainCardContainer>
      <TitleSection>
        <Typography>
          {data?.accountingCode || ""} - {data?.nickName || ""}
        </Typography>
        <BalanceContainer>
          <Typography color={data?.totalBalance >= 0 ? theme.palette.success.main : theme.palette.error.main}>
            {data?.totalBalance === 0 ? "تراز" : data?.totalBalance > 0 ? "بستانکار" : "بدهکار"}
          </Typography>
          <PriceComponent
            color={data?.totalBalance >= 0 ? theme.palette.success.main : theme.palette.error.main}
            price={!data?.totalBalance || data.totalBalance === 0 ? "0" : formatPrice(data?.totalBalance)}
          />
        </BalanceContainer>
      </TitleSection>
      <LowerSection>
        <ProfileSection>
          <Typography textAlign="center" color={theme.palette.primary.main} variant="h6">
            {/*{data?.accountingCode || ''}*/}
          </Typography>
          <ItemContainer>
            <StyledAvatar src={data?.avatar || "/assets/images/profileAvatar.svg"} />
          </ItemContainer>
          <ItemContainer>
            <TagComponent title={data?.formTypeTitle || ""} />
            <RightArrowIcon />
            <TagComponent title={data?.isLegal || ""} />
          </ItemContainer>
        </ProfileSection>
        <DetailsSection>
          <DetailsItem>
            <DetailsSubItem>
              <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                اعتبار مالی
              </DetailsSubItemTitle>
              <PriceComponent
                variant="h6"
                color={theme.palette.primary.main}
                price={formatPrice(data?.credit || 0)}
              />
            </DetailsSubItem>
          </DetailsItem>
          <AddressItem>
            {displayAddress() && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  آدرس
                </DetailsSubItemTitle>
                <Typography variant="body1">{displayAddress()}</Typography>
              </DetailsSubItem>
            )}
            {data?.postalCode && (
              <DetailsSubItem>
                <Typography variant="body1" color={theme.palette.disabled.main}>
                  کد پستی
                </Typography>
                <Typography variant="body1">{data?.postalCode}</Typography>
              </DetailsSubItem>
            )}
          </AddressItem>
          <DetailsItem>
            {data?.phone && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  تلفن
                </DetailsSubItemTitle>
                <Typography variant="body1">{data?.phone}</Typography>
              </DetailsSubItem>
            )}
            {data?.mobile && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  موبایل
                </DetailsSubItemTitle>
                <Typography variant="body1">{data?.mobile || ""}</Typography>
              </DetailsSubItem>
            )}
            {data?.email && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  ایمیل
                </DetailsSubItemTitle>
                <Typography variant="body1">{data?.email || ""}</Typography>
              </DetailsSubItem>
            )}
            {data?.website && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  وب سایت
                </DetailsSubItemTitle>
                <Typography variant="body1">{data?.website || ""}</Typography>
              </DetailsSubItem>
            )}
            {data?.bankAccount && (
              <DetailsSubItem>
                <DetailsSubItemTitle variant="body1" color={theme.palette.disabled.main}>
                  حساب بانکی
                </DetailsSubItemTitle>
                <Typography variant="body1">{data?.bankAccount || ""}</Typography>
              </DetailsSubItem>
            )}
          </DetailsItem>
        </DetailsSection>
      </LowerSection>
    </MainCardContainer>
  );
};

export default MainCard;
